import { makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'
import React from 'react'
import ContentBlock from '../_components/ContentBlock'
import type { PresentationSectionProps } from '../../../..'

const useStyles = makeStyles<Theme, ExpertCollectionsProps>(
  (theme) => ({
    root: {
      background: theme.palette.common.white,
      boxShadow:
        '0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.20)',
      overflow: 'hidden'
    }
  }),
  { name: 'ExpertCollections' }
)

export interface ExpertCollectionsProps {
  classes?: StyleClasses<typeof useStyles>
}

function ExpertCollections(props: PresentationSectionProps) {
  const classes = useStyles(props)

  return (
    <div className={classes.root}>
      <ContentBlock
        imgFirst
        img={'https://paintscout.s3.us-east-1.amazonaws.com/partners/sw/images/expert-collections.png'}
        title={
          <>
            Try Our Color
            <br />
            Expert™ App
          </>
        }
        description={
          <>
            Our next-gen app lets you explore color collections, visualize colors in your space, order samples and more.
          </>
        }
        appLinks={{
          apple: {
            img: 'https://paintscout.s3.us-east-1.amazonaws.com/partners/sw/images/apple-app-store.png',
            href: 'https://apps.apple.com/us/app/sherwin-williams-color-expert/id6466933712'
          },
          google: {
            img: 'https://paintscout.s3.us-east-1.amazonaws.com/partners/sw/images/google-play-button.png',
            href: 'https://play.google.com/store/apps/details?id=com.sherwin.diy'
          }
        }}
        styles={{ padding: '40px' }}
      />
    </div>
  )
}

export default ExpertCollections
